import NavBar from '..//MainPortal/Common/MainNav'
import { LoginBackground } from '../Constants/Backgrounds';
import { orangeButtonCentered } from '../Constants/Styles';
import { useNavigate } from 'react-router-dom';
const LinkDoesNotExist = () => {

    const navigate = useNavigate();
    return (
        <div className="flex flex-col h-screen">
            <NavBar  />
            <div
                className="w-full h-full flex justify-center "
                style={{
                    backgroundImage: `url(${LoginBackground})`,
                    backgroundSize: 'cover',
                    position: 'relative'
                }}
            >
                <div className="absolute inset-0 bg-black opacity-5 z-0" />
                <div className="sm:mt-12 w-full xs:w-[32rem] h-[22rem]  bg-white flex flex-col z-40">
                    <div className="px-16 py-10">
                        <h2 className="mt-8 text-2xl font-semibold">Link does not exist</h2>

                        <p className="text-lg md:text-xl mt-4">Sorry, there is no web page matching your request. The page or file you are looking for has been moved or does not exist.</p>

                        <div className="mt-12 w-full flex justify-center">
                            <button className={orangeButtonCentered} onClick={()=>{navigate('/')}}>
                                Return to the Homepage
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default LinkDoesNotExist;